const API_BASE = "http://localhost:4000/api";

export async function getFacilities() {
  const res = await fetch(`${API_BASE}/facilities`);
  return res.json();
}

export async function getProducts() {
  const res = await fetch(`${API_BASE}/products`);
  return res.json();
}

export async function getInstallations() {
  const res = await fetch(`${API_BASE}/installations`);
  return res.json();
}
